import {GET_ERRORS} from "../storeconstants";

export default {
    [GET_ERRORS](state) {
        return state.errors;
    }
}